(function ($) {
    const { setJQueryHtmlSafely } = window.ihkSanitize || {};
    const searchFinished = new CustomEvent("global-search-finished");
    var lastSearch = '';

    initGlobalSearch();
    function initGlobalSearch(){
        $( document ).ready(function() {
            globalSearchSetLoading();
            applyHandler()
            applySearch();
        });
    }

    function applySearch(){

      currentSearch = getValueByID('global-search-input-text');

      if (currentSearch === lastSearch) {
        console.log('Skip global search');
        return;
      }

      lastSearch = currentSearch;

      globalSearchSetLoading();

      const params = {};
      params["s"] = currentSearch;

      const data  = formatData(params);

      $.ajax({
          type: 'get',
          url: ajaxurl,
          data: {action: 'global_search_form', data},
          success: function (response) {
            if (setJQueryHtmlSafely) {
              setJQueryHtmlSafely($("#global-search__results"), response);
            } else {
              $("#global-search__results").html(response);
            }
            document.dispatchEvent(searchFinished);
          },
          error: function (response) {
            console.log("Error");
            console.log("Did you activate the relevanssi Plugin?");
            //$("#global-search-results").html(response['responseText']);
            document.dispatchEvent(searchFinished);
          }
      });

      $(document).on('global-search-finished', function() {
        globalSearchSetNormal();
      });
    }


    // Handlers
    function applyHandler() {
      const form = document.getElementById('global-search-form');
      if (form) {
        form.addEventListener('submit', applySearch);
      }
    }


    // Helper
    function getValueByID(id) {
      return $( '#' + id ).val();
    }
    function formatData(params) {
      const data  = {};
      for (let param in params) {
          if (params[param] != "") {
              data[param] = params[param];
          }
      }
      return data;
    }

    //set to "loading" Status
    function globalSearchSetLoading() {
      $('#global-search-form #global-search-submit, #global-search-form #global-search-input-text').addClass('disabled');
      $('#global-search__results').removeClass('d-block').addClass('d-none');
      $('#global-search__results__loader').removeClass('d-none').addClass('d-block');
    }

    //set to "normal" Status
    function globalSearchSetNormal() {
      $('#global-search__results').removeClass('d-none').addClass('d-block');
      $('#global-search__results__loader').removeClass('d-block').addClass('d-none');
    }

})(jQuery);

